module.exports = __webpack_public_path__ + "img/p41.276e0a56.png";